import CostBreakdownSelector from '../CostBreakdownSelector';
import CostBreakdownInput from '../CostBreakdownInput';
import { useIntakeForm } from '../../contexts/intakeForm';

const CBInvoiceItemDetailsNonPercentage = ({
  newItem,
  options,
  isPlaster,
  updateState,
  productInfo,
}) => {
  const { materialDropDownList } = useIntakeForm();

  return (
    <>
      <div className='flex flex-col md:flex-row gap-4'>
        <div className='flex w-full md:w-1/2'>
          <CostBreakdownSelector
            value={newItem.name}
            options={Object.keys(options)}
            placeholder='Product / Service'
            onChange={e => {
              updateState(e, 'name');
            }}
          />
        </div>

        {/* Extras / Minimum description field MOBILE ONLY */}
        <div className='flex flex-col md:flex-row items-end w-full md:w-1/2 gap-4'>
          {newItem.name === 'Extras' || newItem.name === 'Minimum' ? (
            <div className='w-full md:hidden'>
              <CostBreakdownInput
                value={newItem.description}
                placeholder={newItem.name === 'Minimum' ? 'Notes' : 'Description'}
                onChange={e => {
                  updateState(e, 'description');
                }}
              />
            </div>
          ) : (
            ''
          )}

          {newItem.name === 'Minimum' ? (
            <CostBreakdownInput
              value={newItem.amountForMinimum}
              placeholder={isPlaster ? 'Total IA' : 'Total Yards'}
              numbersOnly
              onChange={e => {
                updateState(e, 'amountForMinimum');
              }}
            />
          ) : (
            <CostBreakdownInput
              value={newItem.amount}
              placeholder='Amount'
              numbersOnly
              onChange={e => {
                updateState(e, 'amount');
              }}
            />
          )}

          <CostBreakdownInput
            value={newItem.price}
            placeholder='Price'
            money
            disabled={false}
            onChange={e => {
              updateState(e, 'price');
            }}
          />

          {newItem.name === 'Minimum' ? (
            <CostBreakdownInput
              value={Number(newItem.price) || 0}
              placeholder='Total'
              money
              disabled
            />
          ) : (
            <CostBreakdownInput
              value={((Number(newItem.amount) || 0) * (Number(newItem.price) || 0)).toFixed(2)}
              placeholder='Total'
              money
              disabled
            />
          )}
        </div>
      </div>

      {/* Extras / Minimum description field DESKTOP ONLY */}
      {newItem.name === 'Extras' || newItem.name === 'Minimum' ? (
        <div className='hidden md:flex w-full'>
          <CostBreakdownInput
            value={newItem.description}
            placeholder={newItem.name === 'Minimum' ? 'Notes' : 'Description'}
            onChange={e => {
              updateState(e, 'description');
            }}
          />
        </div>
      ) : (
        ''
      )}

      {/* Special fields for PLASTER ONLY */}
      {newItem.name === 'Plaster' ? (
        <div className='flex flex-col gap-4'>
          <div className='flex flex-col md:flex-row w-full gap-4'>
            <div className='w-full md:w-4/6'>
              <CostBreakdownSelector
                value={newItem.manufacturer}
                options={materialDropDownList}
                placeholder='Manufacturer / Product'
                onChange={e => {
                  updateState(e, 'manufacturer');
                }}
              />
            </div>

            <div className='flex flex-col md:flex-row items-end gap-4 w-full md:w-2/6'>
              <CostBreakdownInput
                value={newItem.minIA}
                placeholder='Minimum total IA'
                numbersOnly
                disabled
              />
              <CostBreakdownInput
                value={newItem.minPrice}
                placeholder='Minimum total price'
                money
                disabled
              />
            </div>
          </div>

          <div className='flex flex-col md:flex-row w-full gap-4'>
            <div className='w-full md:w-4/6'>
              <CostBreakdownSelector
                value={newItem.color}
                options={productInfo.colorList}
                placeholder='Color'
                onChange={e => {
                  updateState(e, 'color');
                }}
              />
            </div>

            <div className='block w-full md:w-2/6'>
              <p className='text-xs text-dark-blue pb-[2px] pt-[5px]'>Tier</p>
              <div className='w-full px-3 py-2 rounded border border-tertiary-blue text-opaque-job-details-gray bg-disabled-gray'>
                {newItem.tier}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default CBInvoiceItemDetailsNonPercentage;
